// src/components/Layout.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import "./Layout.css";
import logo from "../assets/logo-fast-caution.png";
import { useTranslation } from "react-i18next";

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <header className="header">
        <div className="header-inner">
          <img src={logo} alt={t("header.logoAlt")} className="header-logo" />
          <div className="burger" onClick={toggleMenu}>
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
          </div>
          <nav className={`nav ${menuOpen ? "open" : ""}`}>
            <NavLink to="/" end className={({ isActive }) => (isActive ? "selected" : "")}>
              {t("header.home")}
            </NavLink>
            <NavLink to="/create" className={({ isActive }) => (isActive ? "selected" : "")}>
              {t("header.create")}
            </NavLink>
            <NavLink to="/pricing" className={({ isActive }) => (isActive ? "selected" : "")}>
              {t("header.pricing")}
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "selected" : "")}>
              {t("header.contact")}
            </NavLink>
            <LanguageSwitcher />
          </nav>
        </div>
      </header>
      <main className="hero">
        <div className="hero-content">{children}</div>
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Fast Caution. {t("footer")}</p>
      </footer>
    </div>
  );
};

export default Layout;
